<template>
  <img src="@/assets/img/banner1800.png" alt="">
</template>

<script>
export default {
  name: 'HochuCredit1800'
}
</script>
